// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconZaiAnimation {
  line-height: 0;
}
@keyframes animatedSvgFirstPath {
  0% {
    opacity: 0.4;
  }
  33% {
    opacity: 1;
  }
  66% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.4;
  }
}
@keyframes animatedSvgSecondPath {
  0% {
    opacity: 0.4;
  }
  33% {
    opacity: 0.4;
  }
  66% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}
@keyframes animatedSvgThirdPath {
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0.4;
  }
  66% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.IconZaiAnimation.animate path:nth-child(1) {
  animation: animatedSvgSecondPath 2000ms ease-in-out infinite;
}
.IconZaiAnimation.animate path:nth-child(2) {
  animation: animatedSvgThirdPath 2000ms ease-in-out infinite;
}
.IconZaiAnimation.animate path:nth-child(3) {
  animation: animatedSvgFirstPath 2000ms ease-in-out infinite;
}`, "",{"version":3,"sources":["webpack://./src/components/IconZaiAnimation/styles.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AAEI;EACE;IACE,YAAA;EAAN;EAEI;IACE,UAAA;EAAN;EAEI;IACE,YAAA;EAAN;EAEI;IACE,YAAA;EAAN;AACF;AAGI;EACE;IACE,YAAA;EADN;EAGI;IACE,YAAA;EADN;EAGI;IACE,UAAA;EADN;EAGI;IACE,YAAA;EADN;AACF;AAII;EACE;IACE,UAAA;EAFN;EAII;IACE,YAAA;EAFN;EAII;IACE,YAAA;EAFN;EAII;IACE,UAAA;EAFN;AACF;AAKI;EACE,4DAAA;AAHN;AAMI;EACE,2DAAA;AAJN;AAOI;EACE,2DAAA;AALN","sourcesContent":[".IconZaiAnimation {\n  line-height: 0;\n\n  &.animate {\n    @keyframes animatedSvgFirstPath {\n      0% {\n        opacity: 0.4;\n      }\n      33% {\n        opacity: 1;\n      }\n      66% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 0.4;\n      }\n    }\n\n    @keyframes animatedSvgSecondPath {\n      0% {\n        opacity: 0.4;\n      }\n      33% {\n        opacity: 0.4;\n      }\n      66% {\n        opacity: 1;\n      }\n      100% {\n        opacity: 0.4;\n      }\n    }\n\n    @keyframes animatedSvgThirdPath {\n      0% {\n        opacity: 1;\n      }\n      33% {\n        opacity: 0.4;\n      }\n      66% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n\n    path:nth-child(1) {\n      animation: animatedSvgSecondPath 2000ms ease-in-out infinite;\n    }\n\n    path:nth-child(2) {\n      animation: animatedSvgThirdPath 2000ms ease-in-out infinite;\n    }\n\n    path:nth-child(3) {\n      animation: animatedSvgFirstPath 2000ms ease-in-out infinite;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
